import { notify } from "../components/common/Notification";
import { AxiosRequestConfig } from "axios";
import { axiosConfig } from "./axiosConfig";

export interface ApiError {
  message: string;
  status: number;
  errors?: any;
}

// ✅ Add notifyMessage flag
export interface RequestConfig extends AxiosRequestConfig {
  notifyMessage?: boolean; // default: false
  customErrorMessage?: string;
}

// ------------------- GET -------------------
export const get = async <T = any>(
  url: string,
  config?: RequestConfig
): Promise<T> => {
  try {
    const response = await axiosConfig.get(url, config);
    return response.data;
  } catch (error: any) {
    handelError(error, config?.notifyMessage);
    return undefined as T;
  }
};

// ------------------- POST -------------------
export const post = async <T = any, D = any>(
  url: string,
  data?: D,
  config?: RequestConfig
): Promise<T> => {
  try {
    const response = await axiosConfig.post(url, data, config);
    return response.data;
  } catch (error: any) {
    handelError(error, config?.notifyMessage);
    return undefined as T;
  }
};

// ------------------- PUT -------------------
export const put = async <T = any, D = any>(
  url: string,
  data?: D,
  config?: RequestConfig
): Promise<T> => {
  try {
    const response = await axiosConfig.put(url, data, config);
    return response.data;
  } catch (error: any) {
    handelError(error, config?.notifyMessage);
    return undefined as T;
  }
};

// ------------------- PATCH -------------------
export const patch = async <T = any, D = any>(
  url: string,
  data?: D,
  config?: RequestConfig
): Promise<T> => {
  try {
    const response = await axiosConfig.patch(url, data, config);
    return response.data;
  } catch (error: any) {
    handelError(error, config?.notifyMessage);
    return undefined as T;
  }
};

// ------------------- DELETE -------------------
export const del = async <T = any>(
  url: string,
  config?: RequestConfig
): Promise<T> => {
  try {
    const response = await axiosConfig.delete(url, config);
    return response.data;
  } catch (error: any) {
    handelError(error, config?.notifyMessage);
    return undefined as T;
  }
};

// ------------------- ERROR HANDLER -------------------
const handelError = (error: any, notifyMessage: boolean = true) => {
  // 🟡 If notification is off → skip toast entirely
  if (!notifyMessage) {
    return;
  }

  // Network issues
  if (
    error.code === "ERR_NETWORK" ||
    error.message?.includes("Network Error")
  ) {
    notify.error(
      "Network Error",
      "Unable to connect to the server. Please check your internet connection."
    );
  }

  // const { status, data } = error.response;
  // const errorMessage =
  //   data?.error?.message ??
  //   data?.message ??
  //   data?.error ??
  //   data?.non_field_errors ??
  //   "An error occurred";
  //   const errorCode = data?.error?.code ?? status;
  //   notify.error(errorCode, errorMessage);
};
